import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  ChequeGiroClearingCreateInput,
  ChequeGiroClearingDeleteInput,
  ChequeGiroClearingModel,
  ChequeGiroClearingUpdateInput,
} from './model';

export function useCreateChequeGiroClearing(
  options?: UseMutationOptions<
    ApiResult<ChequeGiroClearingModel>,
    ApiError,
    ChequeGiroClearingCreateInput
  >,
): UseMutationResult<
  ApiResult<ChequeGiroClearingModel>,
  ApiError,
  ChequeGiroClearingCreateInput
> {
  return useMutation<
    ApiResult<ChequeGiroClearingModel>,
    ApiError,
    ChequeGiroClearingCreateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `cheque-notes/${body.chequeGiroId}/clearings`,
      method: 'POST',
      classType: ChequeGiroClearingModel,
      body: body.body,
    });
  }, options);
}

export function useUpdateChequeGiroClearing(
  options?: UseMutationOptions<
    ApiResult<ChequeGiroClearingModel>,
    ApiError,
    ChequeGiroClearingUpdateInput
  >,
): UseMutationResult<
  ApiResult<ChequeGiroClearingModel>,
  ApiError,
  ChequeGiroClearingUpdateInput
> {
  return useMutation<
    ApiResult<ChequeGiroClearingModel>,
    ApiError,
    ChequeGiroClearingUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `cheque-notes/clearings/${body.chequeGiroClearingId}`,
      method: 'PUT',
      classType: ChequeGiroClearingModel,
      body: body.body,
    });
  }, options);
}

export function useDeleteChequeGiroClearing(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    ChequeGiroClearingDeleteInput
  >,
): UseMutationResult<
  { message: string },
  ApiError,
  ChequeGiroClearingDeleteInput
> {
  return useMutation<
    { message: string },
    ApiError,
    ChequeGiroClearingDeleteInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `cheque-notes/clearings/${body.chequeGiroClearingId}`,
      method: 'DELETE',
    });
  }, options);
}
